var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame112(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#F0C274"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0003 14.5208C20.8487 14.5208 19.1045 16.265 19.1045 18.4166C19.1045 20.5682 20.8487 22.3124 23.0003 22.3124C25.1519 22.3124 26.8962 20.5682 26.8962 18.4166C26.8962 16.265 25.1519 14.5208 23.0003 14.5208ZM17.7295 18.4166C17.7295 15.5056 20.0893 13.1458 23.0003 13.1458C25.9113 13.1458 28.2712 15.5056 28.2712 18.4166C28.2712 21.3276 25.9113 23.6874 23.0003 23.6874C20.0893 23.6874 17.7295 21.3276 17.7295 18.4166Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4385 32.1667C14.4385 28.1142 18.4142 25.0625 23.0001 25.0625C27.5861 25.0625 31.5618 28.1142 31.5618 32.1667C31.5618 32.5464 31.254 32.8542 30.8743 32.8542C30.4946 32.8542 30.1868 32.5464 30.1868 32.1667C30.1868 29.1241 27.1042 26.4375 23.0001 26.4375C18.8961 26.4375 15.8135 29.1241 15.8135 32.1667C15.8135 32.5464 15.5057 32.8542 15.126 32.8542C14.7463 32.8542 14.4385 32.5464 14.4385 32.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame112);
export default __webpack_public_path__ + "static/media/Frame 112.7e439f15d0f84646d9f54995ca40c030.svg";
export { ForwardRef as ReactComponent };